import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

import theme, { media } from "../../../../../../../../../theme";
import Hyperlink from "../../../../../../../../Hyperlink";
import Icon from "../../../../../../../../Icon";

const LinkWrapper = styled.li`
  border: 0;
  background: initial;
  border-top: 1px solid ${theme.colors.veryLightGrey};

  &:last-child {
    border-bottom: 1px solid ${theme.colors.veryLightGrey};
  }

  ${media.laptop} {
    border-top: none;

    &:last-child {
      border-bottom: none;
    }
  }
`;

const StyledHyperlink = styled(Hyperlink)`
  box-sizing: border-box;
  padding: 10px 4px 10px 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${media.laptop} {
    padding: 4px 0;
  }
`;

interface IContentWrapperProps {
  hasImage: boolean;
}

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  color: ${theme.colors.black};
  font-family: ${theme.fonts.regular};
  font-size: ${theme.fontSizes.medium};

  ${(props: IContentWrapperProps): string =>
    props.hasImage ? "img {margin-right: 9px;}" : ""}
`;

interface IProps {
  imgSrc?: string;
  label: string;
  to: string;
  onClick?: () => void;
}

export default class Link extends PureComponent<IProps> {
  public render(): ReactNode {
    const { imgSrc, label, to, onClick } = this.props;

    return (
      <LinkWrapper>
        <StyledHyperlink to={to} onClick={onClick}>
          <ContentWrapper hasImage={!!imgSrc}>
            {imgSrc && <img src={imgSrc} alt={label} />}
            <span>{label}</span>
          </ContentWrapper>
          <Icon name="chevron-droit" size={21} />
        </StyledHyperlink>
      </LinkWrapper>
    );
  }
}
